<template>
	<div :class="theme">
		<div :class="this.theme === 'blue' && isLongChart ? 'foot1' : 'foot'">
			<img :class="this.theme === 'purple' && isLongChart ? 'font1' : 'font'" v-if="language === 'zh'" :src="zhImg" alt="mzsm Image" />
			<img class="font" v-else-if="language === 'en'" :src="enImg" alt="mzsm Image" />
			<div class="qrcode">
				<img class="code-img" :src="qrCodeImage" alt="qrcode Image" />
			</div>
		</div>
	</div>
</template>

<script>
import QRCode from 'qrcode'
import { mapState } from 'vuex'

export default {
	name: 'foot',
	data() {
		return {
			url: '',
			qrCodeImage: '',
			zhImg: '',
			enImg: '',
		}
	},
	computed: {
		...mapState(['theme', 'language', 'jsonData', 'isLongChart']),
	},
	created() {
		this.zhImg = require('../assets/image/' + this.theme + '/mzsm_font.svg')
		this.enImg = require('../assets/image/' + this.theme + '/mzsm_e_font.svg')
		this.url = this.jsonData.h5url
    if (this.url.indexOf("http") === -1) {
      let url = window.location.href;
      this.url = url.substring(0, url.indexOf('/finreport')) + this.url;
    }
		console.log('h5url = ' + this.url)
		this.generateQRCode()
	},
	methods: {
		generateQRCode() {
			QRCode.toDataURL(
				this.url,
				{
					type: 'image/png',
					color: {
						dark: '#000000', // 黑色方块
						light: '#ffffff', // 白色背景（我们设置为透明）
					},
					backgroundColor: {
						dark: 'transparent', // 透明背景
						light: 'transparent',
					},
					margin: 0, // 设置边距为0
				},
				(err, url) => {
					if (err) throw err
					this.qrCodeImage = url
				}
			)
		},
	},
}
</script>

<style lang="scss" scoped>
.red {
	.font {
		width: 1040px;
		height: 99px;
		background: rgba(211, 47, 47, 0.73);
		box-shadow: 2px 2px 10px 6px rgba(211, 47, 46, 0.07);
    border: 1px solid rgba(211, 47, 46, 0.07);
	}
}
.purple {
	.font {
		width: 1040px;
		height: 99px;
		background: #7c62a0;
		box-shadow: 2px 2px 10px 6px rgba(81, 47, 128, 0.07);
		opacity: 0.5;
	}
  .font1 {
		width: 1040px;
		height: 99px;
		background: #7c62a0;
		box-shadow: 2px 2px 10px 6px rgba(81, 47, 128, 0.07);
		opacity: 0.8;
	}
  .foot {
    margin-top: 13px;
  }
}
.blue {
	padding: 0 80px;
	.font {
		width: 980px;
	}
  .foot {
    margin-top: 0;
  }
  .foot1 {
    margin-top: -7px;
    position: relative;
  }
}

.code-img {
	width: 75px;
	height: 75px;
}
.foot {
	margin-top: 7px;
	position: relative;
}

.qrcode {
	position: absolute;
	top: 12px;
	right: 13px;
}
.yellow {
	margin-top: -30px;
	width: 1040px;
	height: 104px;
	background: #f8bc27;
	padding: 0 50px;
	padding-top: 38px;

	.font {
		width: 954px;
		height: 84px;
	}

	.qrcode {
		position: absolute;
		top: 5px;
		right: 0px;
	}
}
</style>
